<div class="wrapper">
  <app-documents-table [data]="tableData" [canEdit]="canEdit" />
</div>
